import React, { useEffect, useState } from 'react';
import { api } from '../../../services/api';
import { InventoryLog } from '../../../types';
import { Clock, Activity, AlertCircle, CheckCircle } from 'lucide-react';

export const InventoryHistory: React.FC<{ adminId: string }> = ({ adminId }) => {
  const [logs, setLogs] = useState<InventoryLog[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLogs();
  }, [adminId]);

  const loadLogs = async () => {
    const data = await api.getInventoryLogs(adminId);
    setLogs(data);
    setLoading(false);
  };

  if (loading) return <div className="py-4 text-center text-gray-400">Loading history...</div>;

  if (logs.length === 0) {
    return (
      <div className="text-center py-8 bg-gray-50 rounded-lg border border-dashed border-gray-300">
        <Activity className="w-8 h-8 text-gray-300 mx-auto mb-2" />
        <p className="text-gray-500">No automated actions taken yet.</p>
      </div>
    );
  }

  return (
    <div className="bg-white border rounded-xl overflow-hidden shadow-sm">
      <div className="p-4 border-b bg-gray-50 flex items-center gap-2">
        <Clock className="w-4 h-4 text-gray-500" />
        <h3 className="font-semibold text-gray-700">Automation History</h3>
      </div>
      
      <div className="divide-y divide-gray-100">
        {logs.map((log) => (
          <div key={log.id} className="p-4 hover:bg-gray-50 transition-colors flex items-start gap-4">
            {/* Icon based on Action */}
            <div className={`mt-1 p-1.5 rounded-full ${
              log.action_type === 'DRAFTED' ? 'bg-amber-100 text-amber-600' : 'bg-green-100 text-green-600'
            }`}>
              {log.action_type === 'DRAFTED' ? <AlertCircle size={16} /> : <CheckCircle size={16} />}
            </div>

            <div className="flex-1">
              <div className="flex justify-between items-start">
                <h4 className="font-medium text-gray-900">{log.product_name}</h4>
                <span className="text-xs text-gray-400 whitespace-nowrap ml-2">
                  {new Date(log.created_at).toLocaleString()}
                </span>
              </div>
              <p className="text-sm text-gray-600 mt-0.5">
                {log.action_type === 'DRAFTED' 
                  ? 'Changed status to Draft (Hidden)' 
                  : 'Changed status to Active (Visible)'}
              </p>
              <p className="text-xs text-gray-400 mt-1">{log.details}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
